// extracted by mini-css-extract-plugin
export default {"wrapper":"Body_wrapper__hF-EY"};